import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import inaccurateData from './assets/InaccurateData.png'
import inaccurateDataWebp from './assets/InaccurateData.webp'
import inaccurateDataWebp2x from './assets/InaccurateData@2x.webp'

const copy = {
  heading: `61% of companies may be losing sleep over the specter of inaccurate data muddying their AI-driven personalization efforts.`,
  description: [
    `This concern underscores a universal truth in the realm of AI: garbage in, garbage out.`,
    `As businesses continue to lean on AI and machine learning for sharper customer insights, ensuring data accuracy is an absolute necessity to avoid the pitfalls of AI/ML algorithms trained on bad data.`,
  ],
}

export const InaccurateData = () => {
  return (
    <Wrapper>
      <SectionComponent variant="2Col">
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            {copy.description.map((text, index) => (
              <CopyText.Description key={index} tag="p">
                {text}
              </CopyText.Description>
            ))}
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <picture>
            <source type="image/webp" srcSet={`${inaccurateDataWebp}, ${inaccurateDataWebp2x} 2x`} />
            <Image width="512" height="617" src={inaccurateData} alt={copy.heading} />
          </picture>
        </Section.Contents>
      </SectionComponent>
    </Wrapper>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default InaccurateData
